import { AcquireEfemLockRequestSchema, AcquireEfemLockResponseSchema, BaseResponseSchema, BatchWaferTransferEfemRequestSchema, BatchWaferTransferEfemResponseSchema, BulkLoadPortsLoadUnloadResponseSchema, CollectWaferImagesRequestSchema, CreateEfemClientSchema, EfemClientAuthenticationResultResponseSchema, EfemClientStatusSchema, EfemGatewayLoadPortParamSchema, EfemGatewaySerialParamSchema, EfemLockStatusResponseSchema, EfemStatusResponseSchema, ExtendEfemLockResponseSchema, ForceReleaseEfemLockResponseSchema, GetEfemClientsResponseSchema, GetEfemClientsWithLocksResponseSchema, LoadPortIdsSchema, ReleaseEfemLockResponseSchema, SlotMapResponseSchema, TenantEfemConfigResponseSchema, TenantEfemConfigSchema, WaferImageCollectionResponseSchema, WaferTransferEfemRequestSchema, } from '../../schemas.js';
import { ArmHandheldBindSchema, ConfirmHandheldBindResponseSchema, ConfirmHandheldBindSchema, HandheldBindPreviewResponseSchema, } from '../../efem-handheld-barcode.schemas.js';
import { EfemLoadPortBindingResponseSchema, EfemTransferVerifyRequestSchema, EfemTransferVerifyResponseSchema, LoadPortsWithBindingsResponseSchema, PatchEfemLoadPortBindingSchema, PostScanContainerRequestSchema, PostScanContainerResponseSchema, } from '../../efem-barcode.schemas.js';
import { waferIdStationAcquireRequestSchema, waferIdStationAcquireResponseSchema, waferIdStationAcquireSaveRequestSchema, waferIdStationAcquireSaveResponseSchema, } from '../../wafer-id-station-acquire.schemas.js';
import { EfemGatewayHardwareProfileResponseSchema, EfemPeripheralMatrixResponseSchema, PutEfemGatewayHardwareProfileSchema, } from '../../efem-wafer-imaging.schemas.js';
const UpdateTenantEfemConfigBodySchema = TenantEfemConfigSchema.partial();
/** REST contract for core `insight-api/src/routes/tenant/efem.routes.ts` endpoints. */
export const efemContract = {
    getStatus: {
        method: 'GET',
        path: '/tenant/efem/status',
        response: EfemStatusResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get EFEM status',
    },
    authenticateClients: {
        method: 'POST',
        path: '/tenant/efem/clients/authenticate',
        response: EfemClientAuthenticationResultResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to authenticate EFEM clients',
    },
    getConfig: {
        method: 'GET',
        path: '/tenant/efem/config',
        response: TenantEfemConfigResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get EFEM configuration',
    },
    initializeConfig: {
        method: 'POST',
        path: '/tenant/efem/config/initialize',
        body: TenantEfemConfigSchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to initialize EFEM configuration',
    },
    updateConfig: {
        method: 'PUT',
        path: '/tenant/efem/config/update',
        body: UpdateTenantEfemConfigBodySchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to update EFEM configuration',
    },
    listClients: {
        method: 'GET',
        path: '/tenant/efem/clients',
        response: GetEfemClientsWithLocksResponseSchema,
        responseStyle: 'parse-response',
        dedupe: true,
    },
    createClient: {
        method: 'POST',
        path: '/tenant/efem/clients',
        body: CreateEfemClientSchema,
        response: GetEfemClientsResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to create EFEM client',
    },
    updateClient: {
        method: 'PUT',
        path: '/tenant/efem/clients/:gatewaySerialNumber',
        pathParams: EfemGatewaySerialParamSchema,
        body: CreateEfemClientSchema,
        response: GetEfemClientsResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to update EFEM client',
    },
    getClientStatus: {
        method: 'GET',
        path: '/tenant/efem/clients/:gatewaySerialNumber/status',
        pathParams: EfemGatewaySerialParamSchema,
        response: EfemClientStatusSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get EFEM client status',
    },
    getLoadPorts: {
        method: 'GET',
        path: '/tenant/efem/clients/:gatewaySerialNumber/loadports',
        pathParams: EfemGatewaySerialParamSchema,
        response: LoadPortsWithBindingsResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get load ports',
    },
    acquireLock: {
        method: 'POST',
        path: '/tenant/efem/:gatewaySerialNumber/lock/acquire',
        pathParams: EfemGatewaySerialParamSchema,
        body: AcquireEfemLockRequestSchema,
        response: AcquireEfemLockResponseSchema,
        responseStyle: 'parse-response',
    },
    releaseLock: {
        method: 'POST',
        path: '/tenant/efem/:gatewaySerialNumber/lock/release',
        pathParams: EfemGatewaySerialParamSchema,
        response: ReleaseEfemLockResponseSchema,
        responseStyle: 'parse-response',
    },
    extendLock: {
        method: 'POST',
        path: '/tenant/efem/:gatewaySerialNumber/lock/extend',
        pathParams: EfemGatewaySerialParamSchema,
        response: ExtendEfemLockResponseSchema,
        responseStyle: 'parse-response',
    },
    getLockStatus: {
        method: 'GET',
        path: '/tenant/efem/:gatewaySerialNumber/lock/status',
        pathParams: EfemGatewaySerialParamSchema,
        response: EfemLockStatusResponseSchema,
        responseStyle: 'parse-response',
    },
    forceReleaseLock: {
        method: 'POST',
        path: '/tenant/efem/:gatewaySerialNumber/lock/force-release',
        pathParams: EfemGatewaySerialParamSchema,
        response: ForceReleaseEfemLockResponseSchema,
        responseStyle: 'parse-response',
    },
    scanContainer: {
        method: 'POST',
        path: '/tenant/efem/clients/:gatewaySerialNumber/loadports/:loadPortId/scan-container',
        pathParams: EfemGatewayLoadPortParamSchema,
        body: PostScanContainerRequestSchema,
        response: PostScanContainerResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to scan container',
    },
    patchLoadPortBinding: {
        method: 'PATCH',
        path: '/tenant/efem/clients/:gatewaySerialNumber/loadports/:loadPortId/binding',
        pathParams: EfemGatewayLoadPortParamSchema,
        body: PatchEfemLoadPortBindingSchema,
        response: EfemLoadPortBindingResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to update load port binding',
    },
    armHandheldBind: {
        method: 'PUT',
        path: '/tenant/efem/clients/:gatewaySerialNumber/handheld-bind/arm',
        pathParams: EfemGatewaySerialParamSchema,
        body: ArmHandheldBindSchema,
        response: HandheldBindPreviewResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to arm handheld bind',
    },
    getHandheldBindPreview: {
        method: 'GET',
        path: '/tenant/efem/clients/:gatewaySerialNumber/handheld-bind/preview',
        pathParams: EfemGatewaySerialParamSchema,
        response: HandheldBindPreviewResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get handheld bind preview',
    },
    confirmHandheldBind: {
        method: 'POST',
        path: '/tenant/efem/clients/:gatewaySerialNumber/handheld-bind/confirm',
        pathParams: EfemGatewaySerialParamSchema,
        body: ConfirmHandheldBindSchema,
        response: ConfirmHandheldBindResponseSchema,
        responseStyle: 'unwrap-data-field',
        dataField: 'bindings',
        errorMessage: 'Failed to confirm handheld bind',
    },
    clearHandheldBindSession: {
        method: 'DELETE',
        path: '/tenant/efem/clients/:gatewaySerialNumber/handheld-bind',
        pathParams: EfemGatewaySerialParamSchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to clear handheld bind session',
    },
    loadContainers: {
        method: 'POST',
        path: '/tenant/efem/clients/:gatewaySerialNumber/loadports/load',
        pathParams: EfemGatewaySerialParamSchema,
        body: LoadPortIdsSchema,
        response: BulkLoadPortsLoadUnloadResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to load containers',
    },
    unloadContainers: {
        method: 'POST',
        path: '/tenant/efem/clients/:gatewaySerialNumber/loadports/unload',
        pathParams: EfemGatewaySerialParamSchema,
        body: LoadPortIdsSchema,
        response: BulkLoadPortsLoadUnloadResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to unload containers',
    },
    getSlotMap: {
        method: 'GET',
        path: '/tenant/efem/clients/:gatewaySerialNumber/loadports/:loadPortId/slotmap',
        pathParams: EfemGatewayLoadPortParamSchema,
        response: SlotMapResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get slot map',
    },
    collectWaferImages: {
        method: 'POST',
        path: '/tenant/efem/clients/:gatewaySerialNumber/wafer/collect-images',
        pathParams: EfemGatewaySerialParamSchema,
        body: CollectWaferImagesRequestSchema,
        response: WaferImageCollectionResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to collect wafer images',
    },
    acquireWaferIdAtStation: {
        method: 'POST',
        path: '/tenant/efem/clients/:gatewaySerialNumber/wafer-id/acquire',
        pathParams: EfemGatewaySerialParamSchema,
        body: waferIdStationAcquireRequestSchema,
        response: waferIdStationAcquireResponseSchema,
        responseStyle: 'unwrap-data',
        timeoutMs: 180000,
        errorMessage: 'Wafer ID acquire failed',
    },
    saveWaferIdStationAcquire: {
        method: 'POST',
        path: '/tenant/efem/wafer-id/acquire/save',
        body: waferIdStationAcquireSaveRequestSchema,
        response: waferIdStationAcquireSaveResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to save wafer ID acquire',
    },
    transferWafer: {
        method: 'POST',
        path: '/tenant/efem/clients/:gatewaySerialNumber/wafer/transfer',
        pathParams: EfemGatewaySerialParamSchema,
        body: WaferTransferEfemRequestSchema,
        response: BatchWaferTransferEfemResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to start wafer transfer',
    },
    batchTransferWafers: {
        method: 'POST',
        path: '/tenant/efem/clients/:gatewaySerialNumber/wafer/transfer/batch',
        pathParams: EfemGatewaySerialParamSchema,
        body: BatchWaferTransferEfemRequestSchema,
        response: BatchWaferTransferEfemResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to initiate batch transfer',
    },
    verifyTransfer: {
        method: 'POST',
        path: '/tenant/efem/transfer/verify',
        body: EfemTransferVerifyRequestSchema,
        response: EfemTransferVerifyResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to verify transfer',
    },
    getHardwareProfile: {
        method: 'GET',
        path: '/tenant/efem/clients/:gatewaySerialNumber/hardware-profile',
        pathParams: EfemGatewaySerialParamSchema,
        response: EfemGatewayHardwareProfileResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get EFEM hardware profile',
    },
    putHardwareProfile: {
        method: 'PUT',
        path: '/tenant/efem/clients/:gatewaySerialNumber/hardware-profile',
        pathParams: EfemGatewaySerialParamSchema,
        body: PutEfemGatewayHardwareProfileSchema,
        response: EfemGatewayHardwareProfileResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to update EFEM hardware profile',
    },
    getPeripheralMatrix: {
        method: 'GET',
        path: '/tenant/efem/clients/:gatewaySerialNumber/peripheral-matrix',
        pathParams: EfemGatewaySerialParamSchema,
        response: EfemPeripheralMatrixResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get EFEM peripheral matrix',
    },
};
//# sourceMappingURL=efem.contract.js.map